import type { HTMLAttributes } from 'react';
import { STYLE_WITH_PRIMARY_COLOR } from './utils';
import { cn } from '@worldcoo/ui/lib/utils';

export function Layout(props: HTMLAttributes<HTMLElement>) {
	return <main {...props} style={STYLE_WITH_PRIMARY_COLOR} />;
}

export function Title(props: HTMLAttributes<HTMLHeadingElement>) {
	return <h1 {...props} className={cn('text-3xl font-bold md:text-5xl', props.className)} />;
}

export function Paragraph(props: HTMLAttributes<HTMLParagraphElement>) {
	return <p {...props} className={cn('text-lg md:text-xl', props.className)} />;
}
